import {
  setFeaturebaseStatusAction,
  setFeaturebaseChangelogAction,
  setFeaturebseTaskAction,
  setFeaturebaseErrorsAction
} from './integrations.actions'

/** @typedef {import('redux').Dispatch} */

const handleStorageAccess = async () => {
  try {
    if (!document.hasStorageAccess) throw new Error('Storage access is required.')

    const hasAccess = await document.hasStorageAccess()
    if (!hasAccess) {
      await document.requestStorageAccess()
      // console.info('Storage access granted')
    }
  } catch (err) {
    console.warn('Storage access denied')
    throw err
  }
}

/**
 *
 * @param {import('../../../../reducers/adminsReducer').CurrentAdmin} currentAdmin
 * @param {import('../../../../contexts/MFAdminAppInitializer/MFAdminAppInitializer.types').MFAdminLayoutSkinType} skin
 * @returns {(dispatch: Dispatch) => void}
 */
export const initializeFeaturebaseIdentify = currentAdmin => async dispatch => {
  try {
    dispatch(setFeaturebaseStatusAction('loading'))
    dispatch(setFeaturebseTaskAction('identity'))
    await handleStorageAccess()

    if (!currentAdmin?.name) return

    if (typeof window.Featurebase !== 'function') {
      window.Featurebase = function () {
        ;(window.Featurebase.q = window.Featurebase.q || []).push(arguments)
      }
    }

    window.Featurebase('identify', {
      appId: '66a91417c971ba693ecfdeb9',
      organization: 'marketfuel',
      userId: String(currentAdmin.id),
      email: currentAdmin.email,
      name: currentAdmin.name,
      userHash: currentAdmin.featurebase_user_hash
    })

    dispatch(setFeaturebaseStatusAction('succeeded'))
  } catch (err) {
    dispatch(setFeaturebaseStatusAction('failed'))
    dispatch(setFeaturebaseErrorsAction({ message: err.message }))
  }
}

export const initializeFeaturebaseChangelog = (currentAdmin, skin) => async dispatch => {
  try {
    dispatch(setFeaturebaseStatusAction('loading'))
    dispatch(setFeaturebseTaskAction('changelog'))
    handleStorageAccess()

    if (!currentAdmin?.name) return

    if (typeof window.Featurebase !== 'function')
      window.Featurebase = function () {
        ;(window.Featurebase.q = window.Featurebase.q || []).push(arguments)
      }

    window.Featurebase(
      'initialize_changelog_widget',
      {
        organization: 'marketfuel',
        placement: 'top',
        theme: skin ?? 'light',
        fullscreenPopup: false,
        locale: 'en',
        usersName: currentAdmin.name,
        jwtToken: currentAdmin.featurebase_authentication_token
      },
      (error, data) => {
        dispatch(setFeaturebaseChangelogAction({ unreadChanges: data.unreadCount || 0 }))

        if (error) throw new Error(error)
      }
    )

    dispatch(setFeaturebaseStatusAction('succeeded'))
  } catch (err) {
    dispatch(setFeaturebaseStatusAction('failed'))
    dispatch(setFeaturebaseErrorsAction({ message: err.message }))
  }
}

export const initializeFeaturebaseMessenger = (currentAdmin, skin) => async dispatch => {
  try {
    dispatch(setFeaturebaseStatusAction('loading'))
    dispatch(setFeaturebseTaskAction('messenger'))
    await handleStorageAccess()

    if (!currentAdmin?.name) return

    if (typeof window.Featurebase !== 'function') {
      window.Featurebase = function () {
        ;(window.Featurebase.q = window.Featurebase.q || []).push(arguments)
      }
    }

    window.Featurebase('boot', {
      appId: '66a91417c971ba693ecfdeb9',
      email: currentAdmin.email,
      userId: String(currentAdmin.id),
      theme: skin ?? 'light',
      language: 'en',
      userHash: currentAdmin.featurebase_user_hash
    })

    dispatch(setFeaturebaseStatusAction('succeeded'))
  } catch (err) {
    dispatch(setFeaturebaseStatusAction('failed'))
    dispatch(setFeaturebaseErrorsAction({ message: err.message }))
  }
}

export const initializeFeaturebaseSurvey = (currentAdmin, skin) => async dispatch => {
  try {
    dispatch(setFeaturebaseStatusAction('loading'))
    dispatch(setFeaturebseTaskAction('survey'))
    await handleStorageAccess()

    if (!currentAdmin?.name) return

    if (typeof window.Featurebase !== 'function') {
      window.Featurebase = function () {
        ;(window.Featurebase.q = window.Featurebase.q || []).push(arguments)
      }
    }

    window.Featurebase('initialize_survey_widget', {
      organization: 'marketfuel',
      placement: 'bottom-right',
      theme: skin ?? 'light',
      locale: 'en',
      usersName: currentAdmin.name,
      jwtToken: currentAdmin.featurebase_authentication_token
    })

    dispatch(setFeaturebaseStatusAction('succeeded'))
  } catch (err) {
    dispatch(setFeaturebaseStatusAction('failed'))
    dispatch(setFeaturebaseErrorsAction({ message: err.message }))
  }
}
